export const disableCorePrefetching = () => true

export const onInitialClientRender = () => {
  window.scrollTo(0, 0);
};
